import { FormikTextInput, useTheme } from "capsule"
import { FormikConfig } from "formik"
import React, { useMemo } from "react"
import { useTranslation } from "react-i18next"
import { View } from "react-native"
import { Text } from "react-native-paper"
import * as Yup from "yup"

import { InputScreen } from "../capsule/components/Screens/InputScreen"
import { INPUT_HEIGHT } from "../features/config/Constants"
import { LoginNS } from "../features/i18n/constants"

export interface RegisterPasswordProviderValues {
  email: string
  password: string
  verifyPassword: string
}

interface IProps {
  loading: boolean
  onSubmit: (values: RegisterPasswordProviderValues) => void
  buttonLabel: string
}
const RegisterPasswordProviderForm = ({ loading, onSubmit, buttonLabel }: IProps) => {
  const { t } = useTranslation(LoginNS)

  const {
    dimensions: { spacing },
    colors: {
      surface: { textInput },
    },
  } = useTheme()

  const { inputStyle, section } = useMemo(
    () => ({
      inputStyle: { backgroundColor: textInput, minHeight: INPUT_HEIGHT },
      section: {
        gap: spacing,
      },
    }),
    [spacing, textInput],
  )
  const formikConfig: FormikConfig<RegisterPasswordProviderValues> = {
    validateOnMount: true,
    onSubmit,
    initialValues: {
      email: "",
      password: "",
      verifyPassword: "",
    },
    validationSchema: Yup.object({
      email: Yup.string().email(t("errors.emailMustBeValid")).required(t("errors.emailNeeded")),
      password: Yup.string()
        .min(8, t("errors.minLength"))
        .matches(/[A-Z]/, t("errors.upperCaseNeeded"))
        .matches(/[0-9]/, t("errors.numberNeeded"))
        .matches(/[^A-Za-z0-9]/, t("errors.specialCharNeeded"))
        .required(t("errors.passwordNeeded")),
      verifyPassword: Yup.string()
        .oneOf([Yup.ref("password")], t("errors.verifyPasswordDontMatch"))
        .required(t("errors.verifyPasswordNeeded")),
    }),
  }
  return (
    <InputScreen
      formikConfig={formikConfig}
      formLoading={loading}
      Inputs={
        <View style={section}>
          <FormikTextInput
            name="email"
            style={inputStyle}
            changeUnderline={false}
            autoCapitalize="none"
            autoCorrect={false}
            testID="register_input_email"
            label={t("email")}
          />
          <FormikTextInput
            name="password"
            style={inputStyle}
            testID="register_input_password"
            secureTextEntry
            changeUnderline={false}
            autoCapitalize="none"
            autoComplete="off"
            autoCorrect={false}
            label={t("password")}
          />
          <View>
            <Text>{t("passwordCaption")} :</Text>
            <Text>- {t("minLength")}</Text>
            <Text>- {t("needUppercase")}</Text>
            <Text>- {t("needNumber")}</Text>
            <Text>- {t("needSpecialChar")}</Text>
          </View>
          <FormikTextInput
            name="verifyPassword"
            style={inputStyle}
            secureTextEntry
            changeUnderline={false}
            autoCapitalize="none"
            autoComplete="off"
            autoCorrect={false}
            testID="register_input_verifyPassword"
            label={t("verifyPassword")}
          />
        </View>
      }
      buttonLabel={buttonLabel}
    />
  )
}
export default RegisterPasswordProviderForm
